// extracted by mini-css-extract-plugin
export default {"NoCommentsTitle":"CommentsContainer_NoCommentsTitle__OfWt-"};